export default {
  data() {
    return {
      invoice: {}
    };
  },
  created: function() {
    this.loadInvoiceInfo();
  },
  methods: {
    loadInvoiceInfo() {
      this.invoice = JSON.parse(this.$route.query.invoice);
    },
    reApply() {
      this.$alert("请联系山东省护理学会，电话：0531-88951587", "重开发票");
    }
  }
};
